<template>
    <ToolButton :Editor="Editor" KnownIcon="RevisionHistory"
        @ToolClick="RevisionHistory()" :Size="10">

    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    methods:{
        RevisionHistory(){
            this.$emit("RevisionHistory");
        }
    },
    props: ["Editor"]
});
</script>